import '../pages.css';
import { Link } from 'react-router-dom';

const EconomyDenture = () => {
    return (
        <div className="page product-detail">
            <section className="product-detail-hero">
                <div className="product-detail-hero-content">
                    <Link to="/products/removable" className="back-link">← Back to Removable Prosthetics</Link>
                    <h1>Economy Denture</h1>
                    <p className="product-tagline">Cost-efficient solution with reliable performance</p>
                </div>
            </section>

            <section className="product-detail-content">
                <div className="content-container">
                    <div className="product-section">
                        <h2>Description</h2>
                        <p>
                            The economy complete denture from <strong>AbELab</strong> is a cost-efficient option that meets essential functional
                            and esthetic requirements. Fabricated using hand-packed acrylic and economy denture teeth, this restoration provides
                            a comfortable fit, satisfactory appearance, and dependable function. It is an ideal solution for edentulous patients
                            seeking an affordable yet reliable prosthetic option.
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EconomyDenture;
